import { getPrismic } from "../utils/get-prismic";
import Prismic from "prismic-javascript";
import * as moment from "moment";
import { inRange } from "./in-range";

const getEventsOnDate = async ({ context, date }) => {
  const formattedDate = moment(date).format("YYYY-MM-DD");
  let events = await getEvents({ context });

  events = events.filter(event => {
    const start = moment(event.data.start_date).format("YYYY-MM-DD");
    const end = event.data.end_date
      ? moment(event.data.end_date).format("YYYY-MM-DD")
      : null;
    return inRange(formattedDate, start, end);
  });
  return events;
};

const getFutureEvents = async ({ context }) => {
  const multiple = true;
  const customPredicate = Prismic.Predicates.dateAfter(
    "my.event.start_date",
    new Date()
  );
  const customPredicateKey = "future-events";
  const options = { orderings: "[my.event.start_date]", pageSize: 100 };
  const events = await getPrismic({
    context,
    multiple,
    options,
    customPredicate,
    customPredicateKey
  });
  return events;
};

const getPastEvents = async ({ context }) => {
  const multiple = true;
  const customPredicate = Prismic.Predicates.dateBefore(
    "my.event.start_date",
    new Date()
  );
  const customPredicateKey = "past-events";
  const options = { orderings: "[my.event.start_date desc]", pageSize: 100 };
  const events = await getPrismic({
    context,
    multiple,
    options,
    customPredicate,
    customPredicateKey
  });
  return events;
};

const getFeaturedEvents = async ({ context }) => {
  const multiple = true;
  const customPredicate = [
    Prismic.Predicates.dateAfter(
      "my.event.start_date",
      moment().format("YYYY-MM-DD")
    ),
    Prismic.Predicates.at("my.event.featured", "Yes")
  ];
  const customPredicateKey = "featured-events";
  const options = { orderings: "[my.event.start_date]", pageSize: 100 };
  const events = await getPrismic({
    context,
    multiple,
    options,
    customPredicate,
    customPredicateKey
  });
  return events;
};

const getEvents = async ({
  context,
  fragment = "document.type",
  value = "event"
}) => {
  const multiple = true;
  const options = { orderings: "[my.event.start_date]", pageSize: 100 };
  const events = await getPrismic({
    fragment,
    value,
    options,
    context,
    multiple
  });
  return events;
};

export {
  getEvents,
  getPastEvents,
  getFutureEvents,
  getFeaturedEvents,
  getEventsOnDate
};
